<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Nueva fórmula</h3>
          <p>...</p>

          <!-- <h4>Características básicas</h4> -->
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <!-- <h4>Características</h4> -->

            <b-form-row class="mt-2">
              <b-col>
                <b-form-row>
                  <b-col :cols="2">
                    <!-- Reference -->
                    <b-form-group
                      id="input-reference"
                      label="Nombre"
                      label-for="reference"
                    >
                      <b-form-input
                        id="reference"
                        v-model="$v.form.reference.$model"
                        :state="validateState('reference')"
                        aria-describedby="input-reference-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-reference-feedback"
                        >Este campo es obligatorio.</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-col>

                  <b-col :cols="10">
                    <!-- Reference -->
                    <b-form-group
                      id="input-formula"
                      label="Fórmula"
                      label-for="formula"
                    >
                      <b-form-input
                        id="formula"
                        v-model="$v.form.formula.$model"
                        :state="validateState('formula')"
                        aria-describedby="input-formula-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-formula-feedback"
                        >Este campo es obligatorio.</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-button class="mt-4" type="submit" variant="primary"
              >Guardar fórmula</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

import * as Sentry from '@sentry/browser';

import Multiselect from 'vue-multiselect';

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminFormulasNewScreen',
  props: {},
  components: { Multiselect, VueCropper },
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: { required },
      formula: { required },
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      reference: '',
      formula: '',

      error: {
        show: false,
        text: '',
      },
    };

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
    };
  },
  created() {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = {
        reference: this.form.reference,
        formula: this.form.formula,
      };

      Sentry.setExtra('data', JSON.stringify(data));
      actions.postFormula(data).then((x) => {
        this.$router.push({ name: 'AdminFormulasScreen' });
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
